/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heavy_Pretty_Hornet_ProsperInputs */

const es_heavy_pretty_hornet_prosper = /** @type {(inputs: Heavy_Pretty_Hornet_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos y condiciones`)
};

const gl_heavy_pretty_hornet_prosper = /** @type {(inputs: Heavy_Pretty_Hornet_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos e condicións`)
};

const en_heavy_pretty_hornet_prosper = /** @type {(inputs: Heavy_Pretty_Hornet_ProsperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and conditions`)
};

/**
* | output |
* | --- |
* | "Terms and conditions" |
*
* @param {Heavy_Pretty_Hornet_ProsperInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const heavy_pretty_hornet_prosper = /** @type {((inputs?: Heavy_Pretty_Hornet_ProsperInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heavy_Pretty_Hornet_ProsperInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_heavy_pretty_hornet_prosper(inputs)
	if (locale === "en") return en_heavy_pretty_hornet_prosper(inputs)
	return es_heavy_pretty_hornet_prosper(inputs)
});